import { useI18n } from "@/lib/i18n";
import { formatPrice } from "@/lib/format";

export function PriceDisplay({
  price,
  originalPrice,
  className,
}: {
  price: number;
  originalPrice?: number | null | undefined;
  className?: string;
}) {
  const { t, lang } = useI18n();
  const onSale = originalPrice != null && originalPrice > price;
  return (
    <span
      className={`inline-flex flex-wrap items-center gap-x-2 gap-y-1 tabular-nums ${className ?? ""}`}
    >
      {onSale && (
        <del className="text-[0.72em] font-medium text-muted-foreground">
          <span className="sr-only">{t("menu.previousPrice")} </span>
          {formatPrice(originalPrice, lang)}
        </del>
      )}
      <span>
        {onSale && (
          <span className="sr-only">{t("menu.currentPrice")} </span>
        )}
        {formatPrice(price, lang)}
      </span>
    </span>
  );
}
